<template>
    <div class="relative">
        
        <!-- Full Screen Dropdown Overlay -->
        <div id="menuCloak" v-show="open" class="fixed inset-0 z-40 bg-gray-300 bg-opacity-25" @click="open = false">
        </div>

        <div @click="open = ! open"
            class="leading-5"
             :class="triggerClasses">
            <slot name="trigger"></slot>
            <svg v-if="caret" class="w-5 h-5 pt-1 ml-0 -mr-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
        </div>


        <transition
            enter-active-class="transition duration-200 ease-out"
            enter-class="transform scale-95 opacity-0"
            enter-to-class="transform scale-100 opacity-100"
            leave-active-class="transition duration-75 ease-in"
            leave-class="transform scale-100 opacity-100"
            leave-to-class="transform scale-95 opacity-0">
            <div v-show="open"
                 class="min-w-[75px] absolute z-50 mt-2 overflow-y-auto rounded-lg shadow-lg max-h-screen-50 leading-5 text-sm ring-1 ring-black ring-opacity-5"
                 :class="[widthClass, alignmentClasses, dropdownClasses]"
                 style="display: none;">
                <div class="shadow-lg" :class="finalContentClasses">
                    <slot name="content" v-bind:closed="close"></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        align: {
            default: 'right'
        },
        width: {
            default: 'full'
        },
        contentClasses: {
            default: () => []
        },
        caret: {
            default: true
        },
        backgroundTheme: {
            type: String,
            default: 'light' // 'light' or 'dark'
        }
    },

        data() {
            return {
                open: false
            }
        },

        created() {
            const closeOnEscape = (e) => {
                if (this.open && e.keyCode === 27) {
                    this.open = false
                }
            }

            this.$once('hook:destroyed', () => {
                document.removeEventListener('keydown', closeOnEscape)
            })

            document.addEventListener('keydown', closeOnEscape)
        },

    computed: {
        widthClass() {
            return {
                '20': 'w-20',
                '48': 'w-48',
                '96': 'w-96',
                '500px': 'w-[500px]',
                'full': 'w-full',
            }[this.width.toString()]
        },

        alignmentClasses() {
            if (this.align === 'left') {
                return 'origin-top-left left-0'
            } else if (this.align === 'right') {
                return 'origin-top-right right-0'
            } else {
                return 'origin-top'
            }
        },

        triggerClasses() {
            return {
                'flex p-2 -mb-2 cursor-default relative z-50': true,
                'cursor-pointer': !this.open,
                'text-gray-700 hover:text-gray-900': this.backgroundTheme === 'light',
                'text-black': this.open && this.backgroundTheme === 'light',
                // 'hover:text-ivory': this.backgroundTheme === 'dark',
                'text-gray-200': this.open && this.backgroundTheme === 'dark'
            }
        },

        dropdownClasses() {
            return this.backgroundTheme === 'light' ? 'bg-white text-gray-700' : 'bg-white text-gray-700';
        },

        finalContentClasses() {
            const defaultClasses = this.backgroundTheme === 'light' 
                ? ['bg-white', 'text-gray-700'] 
                : ['bg-white', 'text-gray-700'];
                // : ['bg-primary-800', 'text-white'];
            
            return [...defaultClasses, ...this.contentClasses];
        }
    },
    methods: {
        close() {
            this.open = false;
        }
    }
}
</script>
